'use client';

import { useEffect, useRef } from 'react';

const TOTAL_LOGOS = 12;

// Logos from public/assets/brands/Logo (1).svg ... Logo (12).svg
const logos = Array.from({ length: TOTAL_LOGOS }).map((_, i) => ({
  id: i,
  src: `/assets/brands/Logo (${i + 1}).svg`,
}));

export default function LogoCarousel() {
  const trackRef = useRef<HTMLDivElement>(null);
  const boxWidth = 200; // match your design (120px logo + margin)

  const repeated = [...logos, ...logos, ...logos]; // repeat 3x
  const middleStartIndex = logos.length; // start from the middle copy

  useEffect(() => {
    const track = trackRef.current;
    if (!track) return;

    let scrollIndex = middleStartIndex;

    // Set initial position to middle copy
    const initialOffset = boxWidth * scrollIndex;
    track.style.transform = `translateX(-${initialOffset}px)`;

    const scroll = () => {
      scrollIndex++;
      const scrollAmount = boxWidth * scrollIndex;

      track.style.transition = 'transform 0.6s ease-in-out';
      track.style.transform = `translateX(-${scrollAmount}px)`;

      // Seamless reset when approaching the end of 2nd copy
      if (scrollIndex >= logos.length * 2) {
        // Snap back to middle copy
        setTimeout(() => {
          track.style.transition = 'none';
          scrollIndex = logos.length;
          const resetOffset = boxWidth * scrollIndex;
          track.style.transform = `translateX(-${resetOffset}px)`;
        }, 700); // wait for transition to finish
      }
    };

    const interval = setInterval(scroll, 5000);
    return () => clearInterval(interval);
  }, []);

  return (
    <div className="relative overflow-hidden w-full py-8">
      <div className="relative w-full overflow-hidden">
        <div
          ref={trackRef}
          className="flex"
          style={{
            willChange: 'transform',
          }}
        >
          {repeated.map((logo, index) => (
            <div
              key={index}
              className="w-[120px] h-[100px] flex items-center justify-center flex-shrink-0 ml-[2.3rem] mr-10"
            >
              <img
                src={logo.src}
                alt={`Brand logo ${logo.id + 1}`}
                className="h-12 w-auto object-contain"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
